var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.highlightUserType)?_c('span',{staticClass:"user-type-highlight",class:_vm.getClass,style:(_vm.getStyle)},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.chipText)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }